import { cn, cva } from '@thinkalpha/ui-core/utils';
import type { VariantProps } from '@thinkalpha/ui-core/utils';
import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {}

export const inputVariants = cva(
    'flex w-full rounded-md file:border-0 file:bg-transparent file:font-medium hover:border-gray-400 focus-visible:border-white focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:outline-hidden disabled:cursor-not-allowed',
    {
        variants: {
            variant: {
                default:
                    'border border-gray-200 bg-background ring-offset-background placeholder:text-gray-250 disabled:opacity-50 dark:border-gray-700',
                light: 'bg-white text-gray-925 ring-offset-background placeholder:text-gray-250 disabled:bg-black',
                errorDefault:
                    'border border-[#4C1919] bg-[#1D110E] ring-offset-background placeholder:text-gray-250 disabled:opacity-50',
                errorLight:
                    'border border-[#7a0808] bg-[#fbcdc1] text-gray-925 ring-offset-background placeholder:text-gray-250 disabled:opacity-50',
            },
            dimensions: {
                default: 'h-10 px-3 py-2 text-md file:text-md',
                sm: 'h-6 px-2.5 py-1 text-sm file:text-sm',
            },
        },
        defaultVariants: {
            variant: 'default',
            dimensions: 'default',
        },
    },
);

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, variant, dimensions, ...props }, ref) => {
    return <input className={cn(inputVariants({ variant, dimensions, className }))} ref={ref} {...props} />;
});
Input.displayName = 'Input';

export { Input };
